"use client";
import {
  useComboboxProviderContext
} from "./H5NQMD66.js";
import {
  useCompositeStoreProps
} from "./VUP7S67H.js";
import {
  usePopoverStoreProps
} from "./5IIPAC4H.js";
import {
  useStore,
  useStoreProps
} from "./2ID5JPOO.js";
import {
  useUpdateEffect
} from "./6WEF4WY5.js";
import {
  __spreadProps,
  __spreadValues
} from "./2SMRF6AD.js";

// src/select/select-store.ts
import * as Core from "@ariakit/core/select/select-store";
function useSelectStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox]);
  store = useCompositeStoreProps(store, update, props);
  store = usePopoverStoreProps(store, update, props);
  useStoreProps(store, props, "value", "setValue");
  useStoreProps(store, props, "setValueOnMove");
  return Object.assign(store, { combobox: props.combobox });
}
function useSelectStore(props = {}) {
  const combobox = useComboboxProviderContext();
  props = __spreadProps(__spreadValues({}, props), {
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  const [store, update] = useStore(Core.createSelectStore, props);
  return useSelectStoreProps(store, update, props);
}

export {
  useSelectStoreProps,
  useSelectStore
};
